<template>
  <div>
    <div class="d-flex">
      <div class="col-1 p-1">Exercice:</div>
      <div class="col-5 p-1">
        <b-skeleton v-if="loading"></b-skeleton>
        <router-link v-else-if="isAdmin" :to="`/admin/exercices/${exercice.id}`" target="_blank">{{
            exercice.titre
          }}
        </router-link>
        <div v-else>{{ exercice.titre }}</div>
      </div>
      <div class="col-1 p-1">Eleve:</div>
      <div class="col-5 p-1">
        <b-skeleton v-if="loading"></b-skeleton>
        <router-link v-else-if="isAdmin" :to="`/admin/eleves/${user.id}`" target="_blank">{{
            user.prenom || user.email
          }}
        </router-link>
        <div v-else>{{ user.prenom || user.email }}</div>
      </div>
  </div>
  <hr>
  <vue-editor
      id="editor"
      v-model="content"
      :editorOptions="editorSettings"
      :editorToolbar="customToolbar"
      ref="editor"
  />
  </div>
</template>

<script>
import {User, Exercice, Auth} from "@/js/caller";
import {TeacherToolbar} from "@/js/toolbar";
import {VueEditor} from "vue2-editor";

export default {
  name : "TextEditorTeacher",
  props: {
    item: Object,
  },
  data() {
    return {
      user    : {},
      exercice: null,
      isAdmin : Auth.IsAdmin(),
      loading : true,

      content       : this.item.texte_corrige || this.item.texte_original,
      customToolbar : TeacherToolbar,
      editorSettings: {scrollingContainer: "html"},
    }
  },
  components: {
    VueEditor,
  },
  created() {
    const P = []
    P.push(User.GetUser(this.item.user).then(user => {
      this.user = user;
    }));
    if (this.item.exercice) P.push(Exercice.Get(this.item.exercice).then(exercice => {
      this.exercice = exercice;
    }));
    Promise.all(P).then(() => {
      this.loading = false
    })
  },
  mounted() {
    console.log(this.$refs);
  },
}
</script>

<style scoped>

</style>